import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import { Modal } from "react-bootstrap";
import { verifyData } from "./CommonFunctions/commonFunctions";

const loaderStyle = {
  position: "absolute",
  zIndex: "1",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

const spinnerStyle = { width: "3.5rem", height: "3.5rem" };

const LoaderErrorSuccess = (props) => {
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [success, setSuccess] = useState(false);
  const [successMessage, setSucessMessage] = useState(null);

  useEffect(() => {
    if (props.loader) {
      setError(false);
      setSuccess(false);
    }
    setLoader(props.loader);
  }, [props.loader]);

  useEffect(() => {
    if (verifyData(props.errorMessage)) {
      setError(true);
      setSuccess(false);
      setErrorMessage(props.errorMessage);
    }
  }, [props.errorMessage]);

  useEffect(() => {
    if (verifyData(props.successMessage)) {
      setError(false);
      setSuccess(true);
      setSucessMessage(props.successMessage);
    }
  }, [props.successMessage]);

  const hideErrorModel = () => {
    setErrorMessage(null);
    if (verifyData(props.callback)) {
      props.callback();
    }
    setError(false);
  };

  const hideSuccessModel = () => {
    setSucessMessage(null);
    if (verifyData(props.callback)) {
      props.callback();
    }
    setSuccess(false);
  };

  const getMessage = (message) => {
    if (typeof message === "object" && message?.error) {
      return message.error;
    }
    return message;
  };

  return (
    <React.Fragment>
      {loader ? (
        <div className=" " style={loaderStyle}>
          <br></br>
          <br></br>
          <Spinner style={spinnerStyle} className="m-4 " color="primary" />
        </div>
      ) : (
        ""
      )}
      <Modal
        size="md modal-dialog-centered"
        show={error}
        onHide={() => hideErrorModel()}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="border-bottom-0"></Modal.Header>
        <Modal.Body>
          <h3 className="text-danger text-center h3 modal-hdr-text">Error!</h3>
          <p className="text-center modal-mid-text" id="as-modal-message">
            {getMessage(errorMessage)}
          </p>
          <div className="text-center modal-btns">
            <button
              className="btn btn-danger"
              id="as-ok"
              onClick={() => hideErrorModel()}
            >
              Ok
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        backdrop="static"
        keyboard={false}
        size="md modal-dialog-centered"
        show={success}
        onHide={() => hideSuccessModel()}
      >
        <Modal.Header closeButton className="border-bottom-0"></Modal.Header>
        <Modal.Body>
          <h3 className="text-success text-center h3 modal-hdr-text">
            Success!
          </h3>
          <p className="text-center modal-mid-text" id="as-modal-message">
            {getMessage(successMessage)}
          </p>
          <div className="text-center modal-btns">
            <button
              className="btn btn-primary"
              id="as-ok"
              onClick={() => hideSuccessModel()}
            >
              Ok
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default LoaderErrorSuccess;
